<section class="contacto">
  <div class="mapa">
    <neo-mapa [clave_matrix_mapaApikeyServidor]="clave_matrix_mapaApikeyServidor" *ngIf="clave_matrix_mapaApikeyServidor">
    </neo-mapa>
  </div>
  <div class="container">
    <div class="contacto-top">
      <div class="contacto-top-blq1">
        <h1>{{tituloPrincipal}}</h1>
      </div>
      <div class="contacto-top-blq2">
        <div class="contacto-top-blq2a">
          <div class="contacto-direccion">
            <div class="text-bold">{{tituloDireccion}}</div>
            <div class="text-light">
              <a *ngIf="linkDireccion; else direccionNoLink" [href]="linkDireccion" title="" target="_blank" rel="nofollow">{{direccion}}</a>
              <ng-template #direccionNoLink>
                <neo-span-inner-html [contenido]="direccion"></neo-span-inner-html>
              </ng-template>
            </div>
          </div>
          <div class="contacto-info" *ngIf="infoTxt != ''">
            <div class="text-bold">{{infoTit}}</div>
            <div class="text-light">
              <neo-span-inner-html [contenido]="infoTxt"></neo-span-inner-html>
            </div>
          </div>
        </div>
        <div class="contacto-top-blq2b">
          <div class="contacto-lnk" *ngIf="telefono1">
            <!-- TODO: Revisar si hacer uso función Matrix DC_STRING_HELPER::telefonoTexto() -->
            <a href="tel:{{telefono1}}" title="" target="_blank">{{telefono1}}</a>
          </div>
          <div class="contacto-lnk" *ngIf="telefono2">
            <!-- TODO: Revisar si hacer uso función Matrix DC_STRING_HELPER::telefonoTexto() -->
            <a href="tel:{{telefono2}}" title="" target="_blank">{{telefono2}}</a>
          </div>
          <div class="contacto-lnk" *ngIf="email1">
            <a href="mailto:{{email1}}" title="" target="_blank">{{email1}}</a>
          </div>
          <div class="contacto-lnk" *ngIf="email2">
            <a href="mailto:{{email2}}" title="" target="_blank">{{email2}}</a>
          </div>
        </div>
        <div class="contacto-top-blq2c">
          <picture>
            <img src="assets/images/icons/pet_friendly.png" alt=""/>
          </picture>
        </div>
      </div>
      <div class="contacto-top-blq3">
        <neo-menu-social></neo-menu-social>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-10 offset-lg-1">
        <neo-formulario-contacto-front [class]="'form-lg'"></neo-formulario-contacto-front>
      </div>
    </div>
  </div>
</section>